import classNames from 'classnames';
import type { FC } from 'react';
import type { THeaderProps } from '@components/Organisms/Header/Header.types';

export const Header: FC<THeaderProps> = ({ children, className, logo }) => {
  const wrapperClassNames = classNames('app-c-header', className);

  return (
    <header className={wrapperClassNames}>
      <img alt="Logo Reverse" className="app-c-header__logo" src={logo} />

      <div className="app-c-header__actions">{children}</div>
    </header>
  );
};
